
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">TERMS OF SERVICE</h4>
        <button type="button" class="close" aria-label="Close" (click)="close.emit(true)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="p-2">
            Last updated and effective as of May 1st, 2020.
        </div>
        <div class="p-2">
            Welcome to the FocusOnline website (this “Site”). This Site is owned and operated by Focus POS Systems
            Inc. (“Focus POS”). This Terms of Service (these “Terms”) governs your use of the Site and services
            provided through the Site. PLEASE READ THE FOLLOWING TERMS CAREFULLY BEFORE ACCESSING OR USING THE SITE
            AND/OR PLACING ANY ORDER THROUGH THIS SITE.
        </div>
        <div class="p-2 ms-2">
            1. General. By [clicking the “I Accept” box] and/or accessing or using this Site in any way, including
            without limitation, browsing this Site, placing an Order (as defined herein), using any information,
            and/or submitting any content or personal information to Focus POS through the Site, you agree to and
            are bound by the terms, conditions, Privacy Policy (available at focuspos.com and incorporated as a part
            of these Terms by this reference) and notices contained in these Terms, as updated from time to time. By
            clicking the “I Accept” box and/or using the Site, you affirm that you are more than 18 years of age and
            agree to abide by and comply with these Terms. Please review these Terms carefully and periodically for
            any updates or changes as terms may change without notice. YOUR CONTINUED USE OF THIS SITE FOLLOWING
            CHANGES MADE TO ANY OF THESE TERMS CONSTITUTES ACCEPTANCE OF THOSE CHANGES.
        </div>
        <div class="p-2 ms-2">
            2. Terms of Sale.
            <div class="p-2 ms-2">
                (a) Focus POS allows you to place orders for food and products offered through the Site (each, an
                “Order”)
                from member restaurants participating on the Site (each, a “Merchant”). You agree that Focus POS is
                solely
                an independent website to take Orders for the Merchant. Merchant, not Focus POS, is the seller of its
                food
                and products, and as such, Focus POS is not responsible or liable for the food or products or any Order
                or
                attempted Order, in whole or in part, made in connection with this Site. You hereby release and agree to
                hold Focus POS and its officers, directors, employees, agents, successors, divisions, distributors,
                suppliers and affiliates harmless from any and all liability for any damages, costs, expenses or losses
                arising out of or incurred in connection with any products and services offered by a Merchant through
                the
                Site and any Order submitted by you. THE FOOD PRODUCTS AND OTHER GOODS ARE OFFERED ON AN “AS IS,” AND
                “AS
                AVAILABLE” BASIS.
            </div>
            <div class="p-2 ms-2">
                (b) By placing an Order, you accept all the terms and conditions in these Terms and/or applicable to the
                Order. You are responsible for paying all fees and applicable taxes associated with any Order you submit
                as
                such fees and taxes become due with a valid method of payment Request. The prices of the food and
                products
                set forth on the Site are subject to change. The final charges for each Order may contain additional
                processing, service and/or delivery fees as dictated by Merchant or any third-party payment Request
                processor. When you place an Order, prior to final submission, you will have an opportunity to review
                the
                final Order and accept the fees charged. Unless otherwise stated all fees are in U.S. Dollars. ALL SALES
                ARE
                FINAL. If technical problems or any other problems prevent or unreasonably delay processing or delivery
                (if
                applicable) of any Order, your sole and exclusive remedy is a refund of the price paid.
            </div>
            <div class="p-2 ms-2">
                (c) To submit an Order, you must have a valid credit card and be an authorized user of the credit card.
                Prior to the placement of any Order, you must provide us with (i) a valid credit card number; (ii) your
                name
                as it appears on the card; (iii) the credit card type (i.e., VISA, AMEX); (iv) the credit card
                expiration
                date; and (v) any card ID number necessary to charge your credit card. Some situations may result in
                your
                Order being cancelled, including without limitation problems with respect to your credit card
                information.
            </div>
            <div class="p-2 ms-2">
                (d) Special Offers; Promo Codes. Occasionally Merchants may make available through the Site special
                promotions of Merchant, which may include without limitation promotion or promo codes, or other
                promotional
                activity associated with an Order. These offers may be for a limited time only and are subject to
                change,
                alteration or termination by Merchant in its sole discretion at any time. Merchant, not Focus POS, is
                offeror of such promotions, and as such, Focus POS is not responsible or liable for the promotions,
                promotion codes or other special offers, in whole or in part, made in connection with this Site. Focus
                POS
                reserves the right, in its sole discretion, to not permit a promotion, promotion code or other special
                offer
                in connection with your Order and may charge you the full non-discounted amount for an Order even if you
                have provided a promo code or other discount information in connection with such Order.
            </div>
        </div>

        <div class="p-2 ms-2">
            3. User Names and Passwords. In order to access certain features on this Site and to place an Order, you may
            be
            required to create an account. You are responsible for protecting and maintaining the secrecy of your
            username and password. Focus POS will not be responsible or liable for any loss or damage that results from
            your failure to comply with this security obligation. You are solely responsible for any and all activities
            that occur under your account, whether or not you have authorized such activities. You agree to immediately
            notify Focus POS of an unauthorized use of your username or password. Focus POS reserves the right to
            terminate any account at any time for any reason.
            Site Content.
        </div>
        <div class="p-2 ms-2">
            4. Site Content.
            <div class="p-2 ms-2">
                (a) Except for Merchant content, all contents of this Site are ©Focus POS. All rights reserved. Focus
                POS
                and the Focus POS logo and all other logos, trademarks and service marks contained on this Site are
                trademarks of Focus POS Systems Inc. and/or third-party licensors. This Site contains copyrighted
                material,
                trademarks, service marks, trade dress and other proprietary content, including but not limited to text,
                software, sound, photographs, images, logos, icons, artwork, messages, video, graphics and the HTML used
                to
                generate the pages contained within this Site (the “Content”), and the entire selection, coordination,
                arrangement and “look and feel” of this Site and the Content are copyrighted as a collective work under
                United States copyright laws.
            </div>
            <div class="p-2 ms-2">
                (b) Except as provided in these Terms, you may not use, modify, download, upload, copy, republish,
                frame,
                print, display, perform, reproduce, license, publish, delete, transfer, sell, assign, post, transmit,
                distribute, reverse engineer, create derivative works from, or otherwise exploit any Content or
                information
                from this Site, in whole or in part, for any commercial or public purpose, without the express written
                permission of Focus POS.
            </div>
            <div class="p-2 ms-2">
                (c) This Site is available worldwide to anyone with Internet access. However, this Site may not be
                continuously available. Further, the inclusion of any products, goods, restaurants, items, descriptions,
                or
                locations on this Site at a particular time does not guarantee that the products, goods, restaurants,
                items,
                descriptions, or locations will be available. The Content of this Site, including advertising content,
                is
                intended for use and display only where its use and display are permissible in accordance with
                applicable
                laws and regulations.
            </div>
            <div class="p-2 ms-2">
                (d) Certain materials and designations on this Site may be furnished by third parties, including
                advertisements, or mentioned for identification purposes only. Third-party trademarks, trade names,
                logos,
                product or services names contained on this Site are the trademarks, registered or unregistered, of
                their
                respective owners. Focus POS is not liable for any infringement of copyrights, trademarks, trade dress
                or
                other proprietary rights arising out of content posted on or transmitted through this Site, or items or
                products listed on this Site, by third parties.
            </div>
            <div class="p-2 ms-2">
                (e) Nothing contained in these Terms shall be construed as conferring any other license or right,
                express or
                implied, under any of our intellectual property rights or under any third party's intellectual property
                rights. Any rights not expressly granted herein are reserved.
            </div>
        </div>
        <div class="p-2 ms-2">
            5. User Conduct. By using this Site, including placing an Order through the Site, you agree that you shall
            not:
            <div class="p-2 ms-2">
                (a) delete, modify, hack or attempt to change or alter any of the Content on the Site;
            </div>
            <div class="p-2 ms-2">
                (b) use any device, software or routine intended to damage or otherwise interfere with the proper
                functioning of the Site or servers or networks connected to the Site, or take any other action that
                interferes with other parties' use of the Site;
            </div>
            <div class="p-2 ms-2">
                (c) use any robot, spider or other automatic or manual device or process for the purpose of harvesting
                or
                compiling information on the Site for purposes other than for a generally available search engine;
            </div>
            <div class="p-2 ms-2">
                (d) use any Focus POS names, service marks, or trademarks without our prior written consent, including
                without limitation as metatags, search engine keywords, or hidden text;
            </div>
            <div class="p-2 ms-2">
                (e) use any material or information, including images or photographs, which are made available through
                this
                Site in any manner that infringes any copyright, trademark, patent, trade secret, or other proprietary
                right
                of any party;
            </div>
            <div class="p-2 ms-2">
                (f) upload files that contain viruses, Trojan horses, worms, time bombs, cancelbots, corrupted files, or
                any
                other similar software or programs that may damage the operation of another's computer or property;
            </div>
            <div class="p-2 ms-2">
                (g) impersonate any third party or provide false information on your account information; or
            </div>
            <div class="p-2 ms-2">
                (h) use this Site in violation of any applicable law.

            </div>
        </div>
        <div class="p-2 ms-2">
            6. Permissible Use. Except as indicated to the contrary elsewhere on this Site, you may view, copy,
            retransmit
            and print materials and information available on this Site subject to the following conditions:
            <div class="p-2 ms-2">
                (a) the Content is used solely for personal, informational, or non-commercial purposes;
            </div>
            <div class="p-2 ms-2">
                (b) the Content is not provided, sold, licensed or leased (nor is access provided to the Content) for
                any
                fee or other consideration;
            </div>
            <div class="p-2 ms-2">
                (c) all copyright, trademark and other proprietary rights notices included in the Content as presented
                on
                this Site appear on all copies;
            </div>
            <div class="p-2 ms-2">
                (d) the Content is not modified or altered in any way; and
            </div>
            <div class="p-2 ms-2">
                (e) no graphics are used separately from accompanying text.

            </div>
        </div>

        <div class="p-2 ms-2">
            7. You may also link or hyperlink to the home page of the Site from any Acceptable Site (as defined below),
            but
            only if:
            <div class="p-2 ms-2">
                (a) you do not frame the Site or any portion of the Site;
            </div>
            <div class="p-2 ms-2">
                (b) you do not deep link into the Site (i.e., you do not link into any page other than the home page of
                the
                Site);
            </div>
            <div class="p-2 ms-2">
                (c) the hyperlink to the Site is not used in a way that suggests that Focus POS endorses you or your
                website;
            </div>
            <div class="p-2 ms-2">
                (d) the link to the Site is not used or presented in any way that disparages Focus POS or tarnishes,
                blurs
                or dilutes the quality of Focus POS’s names or trademarks or any associated goodwill; and
            </div>
            <div class="p-2 ms-2">
                (e) the link to the Site is not displayed on any web page that displays objectionable content or links.
                An "Acceptable Site" means a website that displays no objectionable content, including, but not limited
                to,
                any content, information in any medium or format, such as text, data, graphics, audio or video, that:
                (i) is
                libelous or defamatory, pornographic, sexually explicit, unlawful or plagiarized; (ii) a reasonable
                person
                would consider harassing, abusive, threatening, harmful, profane, obscene, racially, ethnically or
                otherwise
                objectionable or offensive in any way; (iii) constitutes a breach of any person's privacy or publicity
                rights, a misrepresentation of facts or hate speech; or (iv) violates or encourages others to violate
                any
                applicable law.
            </div>
        </div>

        <div class="p-2 ms-2">
            8. Termination of Site/Modifications to Site. Focus POS reserves the right to modify or terminate your
            access
            to the Site (or portions of the Site) at any time, with or without notice to you, and is not obligated to
            support or update the Site. Sections 1-2, Sections 4-7, and Sections 9-16 of these Terms and the Privacy
            Policy shall survive any termination. You acknowledge and agree that Focus POS will not be liable to you or
            any third party in the event that Focus POS exercises its right to modify or terminate access to the Site or
            portions of the Site.
        </div>

        <div class="p-2 ms-2">
            9. Other Sites, Content, Products and Services. As a convenience to you, this Site may provide links to web
            sites and access to content, products and services of third parties, including without limitation Focus
            POS’s affiliates, advertisers, strategic partners and Merchants and other entities with which our connection
            consists of only a hyperlink (“Linked Sites”). You should refer to the separate terms of use, privacy
            policies, and other rules posted on Linked Sites before you use them. Focus POS does not author, edit or
            monitor these Linked Sites, and is not responsible or liable for: (a) the availability of or content
            provided on such Linked Sites, nor does inclusion of any link imply endorsement of the Linked Sites by Focus
            POS, or vice versa; (b) third-party content accessible through such Linked Sites; (c) any loss or damage
            whatsoever you may incur from dealing with any Linked Site; (d) your dealings with any third parties found
            on or through this Site; and (e) the accuracy, relevance, timeliness, completeness or appropriateness for a
            particular purpose of the information or the resources contained on these or any Internet sites. The fact
            that Focus POS offers such links should not be construed in any way as an endorsement, authorization or
            sponsorship of that site or its content, products or services.
        </div>

        <div class="p-2 ms-2">
            10. Typographical Errors. This Site may contain typographical mistakes, inaccuracies, or omissions, and some
            information may not be complete or current. Focus POS therefore reserves the right to: (i) revoke any stated
            offer; (ii) correct any errors, inaccuracies or omissions; and (iii) make changes to prices, Content,
            promotional offers, descriptions, or any other information without obligation to issue any notice of such
            changes.
        </div>

        <div class="p-2 ms-2">
            11. Disclaimer. TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, THIS SITE AND ALL CONTENT,
            MATERIALS,
            INFORMATION, PRODUCTS AND SERVICES PROVIDED ON THIS SITE (WHETHER PROVIDED BY Focus POS, MERCHANTS, YOU, OR
            THIRD PARTIES) ARE PROVIDED ON AN "AS IS, WHERE IS" AND "AS AVAILABLE" BASIS AND WITH ALL FAULTS. Focus POS
            EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO,
            THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT,
            SECURITY AND ACCURACY, AS WELL AS ALL WARRANTIES ARISING BY USAGE OF TRADE, COURSE OF DEALING, OR COURSE OF
            PERFORMANCE. Focus POS MAKES NO WARRANTY, AND EXPRESSLY DISCLAIMS ANY OBLIGATION, THAT: (A) THE SITE WILL
            MEET YOUR REQUIREMENTS OR WILL BE AVAILABLE ON AN UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; (B)
            THE CONTENT OR ANY SUBMISSION WILL BE UP-TO-DATE, COMPLETE, COMPREHENSIVE OR ACCURATE; (C) THE RESULTS THAT
            MAY BE OBTAINED FROM THE USE OF THE SITE; (D) THE QUALITY OF ANY PRODUCTS, SERVICES, INFORMATION, GOODS,
            ORDERS OR OTHER MATERIAL OBTAINED BY YOU THROUGH THE SITE WILL MEET YOUR EXPECTATIONS; (E) THAT DEFECTS, IF
            ANY, WILL BE CORRECTED; (F) THAT ALL ORDERS WILL BE FULFILLED; OR (G) THIS SITE OR THE SERVER(S) THAT MAKES
            IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
            YOU UNDERSTAND AND AGREE THAT ANY CONTENT, GOODS, ORDERS AND/OR DATA DOWNLOADED OR OTHERWISE OBTAINED
            THROUGH THE USE OF THIS SITE IS USED AT YOUR OWN RISK.
        </div>

        <div class="p-2 ms-2">
            12. Limitation of Liability. IN NO EVENT SHALL Focus POS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
            PUNITIVE, INCREASED OR CONSEQUENTIAL DAMAGES, LOSS OF PROFITS, REVENUE, DATA, GOODWILL OR USE INCURRED BY
            YOU OR ANY THIRD PARTY, WHETHER IN AN ACTION IN CONTRACT OR TORT (INCLUDING NEGLIGENCE AND STRICT
            LIABILITY), ARISING FROM ANY ORDER, YOUR ACCESS TO OR INABILITY TO ACCESS, OR USE OF, THIS SITE OR ANY
            SERVICES PROVIDED IN CONNECTION WITH THIS SITE, EVEN IF Focus POS HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES. THIS LIMITATION ON LIABILITY APPLIES TO, BUT IS NOT LIMITED TO, THE TRANSMISSION OF ANY
            DISABLING DEVICE OR VIRUSES WHICH MAY INFECT YOUR EQUIPMENT OR SYSTEM, FAILURE OF MECHANICAL OR ELECTRONIC
            EQUIPMENT OR COMMUNICATION LINES, TELEPHONE OR OTHER INTERCONNECT PROBLEMS, UNAUTHORIZED ACCESS, THEFT,
            BODILY INJURY, PROPERTY DAMAGE, ERRORS, DEFAMATION, LIBEL, SLANDER, OMISSION, FALSEHOOD, OBSCENITY,
            PORNOGRAPHY, PROFANITY, INACCURACY CONTAINED THEREIN OR HARM TO PERSON OR PROPERTY CAUSED THEREBY, OPERATOR
            ERRORS, STRIKES OR OTHER LABOR PROBLEMS OR ANY FORCE MAJEURE. SOME JURISDICTIONS DO NOT ALLOW CERTAIN
            LIMITATIONS OR EXCLUSIONS OF LIABILITY IN SOME CIRCUMSTANCES. CONSEQUENTLY, SOME OF THE FOREGOING
            LIMITATIONS MAY NOT APPLY TO YOU. IN NO EVENT SHALL Focus POS’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES,
            LOSSES AND CAUSES OF ACTION, WHETHER IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE) OR
            OTHERWISE EXCEED (A) THE AMOUNT PAID BY YOU TO Focus POS OR A MERCHANT FOR THE GOOD OR PRODUCT GIVING RISE
            TO THE CLAIM, OR (B) ONE HUNDRED DOLLARS ($100.00) (WHICHEVER IS LESS).
        </div>

        <div class="p-2 ms-2">
            13. Indemnity. By using this Site, you agree to indemnify, defend and hold Focus POS, its affiliates,
            shareholders, directors, officers, employees and agents (collectively, the Focus POS Indemnitees”) harmless
            from and against any claim, demand, liability, dispute, damage, cost, expense, or loss, including attorneys'
            fees and costs of litigation, arising out of or in any way related to (i) your use of or access to this Site
            and/or any Content; or (ii) your violation of these Terms. You agree to cooperate as fully as reasonably
            required in the defense of any claim. Focus POS reserves the right to assume the exclusive defense and
            control of any matter subject to indemnification by you for which you will remain responsible for
            indemnifying and holding harmless the Focus POS Indemnitees.
        </div>

        <div class="p-2 ms-2">
            14. Limitation on Actions Brought Against Focus POS. You agree that any claim or cause of action arising out
            of
            your use of this Site or these Terms must be filed within one year after such claim or cause of action arose
            or it shall forever be barred, notwithstanding any statute of limitations or other law to the contrary.
            Within this period, any failure by Focus POS to enforce or exercise any provision of these Terms or related
            right shall not constitute a waiver of that right or provision.
        </div>

        <div class="p-2 ms-2">
            15. Dispute Resolution. These Terms shall be governed exclusively by the laws of the State of Texas, without
            regard to its conflicts or choice of law rules. EACH PARTY ALSO HEREBY WAIVES ANY RIGHT TO JURY TRIAL IN
            CONNECTION WITH ANY ACTION OR LITIGATION RELATED TO THESE TERMS. All disputes or claims arising out of or
            related to these Terms shall be determined exclusively by arbitration in accordance with the expedited rules
            of Judicial Arbitration and Mediation Services (“JAMS”) before a single arbitrator. Such arbitration shall
            be conducted in San Antonio, Texas. The award of such arbitration shall be confidential, final, binding and
            non-appealable, except to the extent provided for in the rules of JAMS, and judgment on the arbitration
            award may be entered into any court having jurisdiction. Each party shall bear its own legal fees and costs.
            Notwithstanding the foregoing, a party may seek injunctive relief from any court of competent jurisdiction
            pending the outcome of any dispute resolution procedure set forth in this section. ARBITRATOR SHALL NOT
            AWARD ANY PARTY DAMAGES THAT ARE INCONSISTENT WITH THESE TERMS.
            BECAUSE THE USE OF THIS SITE REQUIRES THE ARBITRATION OF ANY CLAIMS OR DISPUTES EXISTING BETWEEN THE
            PARTIES, NEITHER PARTY WILL HAVE THE RIGHT TO PURSUE THAT CLAIM IN COURT OR BEFORE A JUDGE OR JURY OR TO
            PARTICIPATE IN A CLASS ACTION OR ANY OTHER COLLECTIVE OR REPRESENTATIVE PROCEEDING. THE ARBITRATORS'
            DECISION WILL BE FINAL AND BINDING. OTHER RIGHTS THAT EITHER PARTY WOULD HAVE IF SUCH PARTY WENT TO COURT,
            INCLUDING WITHOUT LIMITATION THE RIGHT TO CONDUCT DISCOVERY OR TO APPEAL, MAY BE LIMITED OR UNAVAILABLE IN
            ARBITRATION.
            Should this Section 14 be deemed invalid or otherwise unenforceable for any reason, it shall be severed and
            the parties agree that exclusive jurisdiction and venue for any claims will be in state or federal courts in
            San Antonio, Texas.
        </div>

        <div class="p-2 ms-2">
            16. General. If any provision in these Terms is found by a court or arbitrator to be invalid, the parties
            agree
            that the court or arbitrator should give effect to the parties' intentions as reflected in the provision,
            and the other provisions of these Terms will remain in full force and effect. Focus POS’s failure to act
            with respect to a breach by any visitor using the Site does not constitute a waiver of its right to act with
            respect to subsequent or similar breaches. These Terms will be governed by and construed in accordance with
            the laws of the State of Texas without regard to its choice of law provisions. In the event of any conflict
            between foreign laws, rules and regulations and those of the United States, the laws, rules and regulations
            of the United States will govern. These Terms and the Privacy Policy as posted from time to time by Focus
            POS on this Site, and any modifications to the foregoing, constitute the entire agreement between the
            parties with regard to the subject matter in these Terms and supersede all prior understandings and
            agreements, whether written or oral, as to such subject matter.
        </div>

        <div class="p-2 ms-2">
            17. Acknowledgement; Copyright Protection; Contact Information. You acknowledge (a) that you have read and
            understood these Terms; and (b) that these Terms have the same force and effect as a signed agreement. If
            you have any questions about these Terms, the practices of Focus POS, or your dealings with this Site,
            please contact us through the address below. We respond to notices of alleged copyright infringement and
            terminate accounts of repeat infringers according to the process set out in the U.S. Digital Millennium
            Copyright Act. If you think somebody is violating your copyrights and want to notify us, please visit
            http://focuspos.com
        </div>
    </div>
